/**
 * Words for passkey links: a one-time link you send someone so they can make a new passkey for
 * their account (lost passkey, another browser or phone). {name} = their full name.
 */

// ---- Accounts: one account's drawer
/** The button that makes the link and opens the share sheet (or copies it). */
export const LINK_MAKE_BUTTON = "Send a passkey link";
/** The same button when a link is already out (making one turns the old one off). */
export const LINK_REMAKE_BUTTON = "Send a new passkey link";
/** Under the buttons while a link works ({until} = "Oct 31, 12:00"). Empty hides it. */
export const LINK_OPEN_TEXT = "Passkey link works until {until}, once.";
/** Turns the link off. */
export const LINK_OFF_BUTTON = "Turn off link";
/** Toasts. */
export const LINK_COPIED_TOAST = "Copied {name}'s passkey link. It works once, for 72 hours.";
export const LINK_OFF_TOAST = "Turned off {name}'s passkey link";
export const LINK_COPY_FAILED = "Couldn't copy. Here's the link: {url}";
export const LINK_RESET_TOAST =
  "Removed {name}'s passkeys. Send them a passkey link to make a new one.";
/** The text sent with the link ({url}). */
export const LINK_SHARE_TITLE = "Your Split Ledger passkey";
export const LINK_SHARE_TEXT = "Make a new passkey for Split Ledger here (works once): {url}";

// ---- the page the link opens (/k/...)
export const PAGE_EYEBROW = "Split Ledger";
/** {name} = whose account it is. */
export const PAGE_TITLE = "{name}";
export const PAGE_TEXT =
  "Make a passkey on this device to sign in. Your other passkeys keep working.";
export const PAGE_BUTTON = "Create passkey";
/** Someone else is signed in here (often Miles checking the link). {me} = who. */
export const PAGE_OTHER_SIGNED_IN =
  "You're signed in as {me}. Creating a passkey here signs you in as {name} instead.";
/** The treasurer opened it: copy instead. */
export const PAGE_COPY_BUTTON = "Copy link";
export const PAGE_COPIED_TOAST = "Copied the passkey link";
export const PAGE_COPY_FAILED = "Couldn't copy. Copy it from the address bar.";
export const PAGE_LOADING = "Loading…";
export const PAGE_BROKEN_TITLE = "This link doesn't work";
/** After the reason from the server. */
export const PAGE_BROKEN_TEXT = "Ask Miles for a new one.";
export const PAGE_UNSUPPORTED =
  "This browser doesn't support passkeys. Try Safari, Chrome or Edge.";
export const PAGE_OFFLINE = "You're offline. Try again when you're connected.";
export const PAGE_DONE_TOAST = "Passkey made. You're signed in.";
